import * as THREE from "three";


export class Pendrive {
  constructor(store, parent) {
    this.store = store;
    this.parent = parent;
    this.group = new THREE.Group();
    this.parent.add(this.group);
    this.model = null;
    this.load();
  }

  async load() {
    this.model = this.store.assetManager.getModel("pendrive");
    this.model.scale.setScalar(.06);
    this.model.userData.type = "pendrive";
    this.model.userData.instance = this;
    //CLICKABLES TÖMBBŐL NEM TÖRÖLHETŐ
    this.model.userData.baseObject = true;
    this.model.position.set(-9, 4, -6);
    this.model.rotation.x = THREE.MathUtils.degToRad(10);
    this.model.rotation.y = THREE.MathUtils.degToRad(-45);
    this.model.rotation.z = THREE.MathUtils.degToRad(0);
    this.model.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    this.group.add(this.model);
    this.store.input.clickables.push(this.model);
    this.group.updateWorldMatrix(true, true);
  }

  update() {
    if (!this.model) { return; }
    this.group.updateWorldMatrix(true, true);
  }


  getWorldPosition() {return this.group.getWorldPosition(new THREE.Vector3());}

  dispose() {
    this.parent.remove(this.group);
  }

}